import { useEffect } from 'react'

export function useDescription(...descriptions: (string | number | undefined | null)[]) {
  useEffect(() => {
    const description = descriptions.filter((content) => `${content ?? ''}`.length > 0).join(' ')
    const descriptionTag = document.querySelector("meta[name='description']")
    if (descriptionTag) descriptionTag.setAttribute('content', description)
  }, [descriptions])
}
